// HeroModel.js
import img1 from '@assets/1.webp';
import part1_1 from '@assets/1-part-1.webp';
import part1_2 from '@assets/1-part-2.webp';
import part1_3 from '@assets/1-part-3.webp';
import img2 from '@assets/2.webp';
import part2_1 from '@assets/2-part-1.webp';
import part2_2 from '@assets/2-part-2.webp';
import part2_3 from '@assets/2-part-3.webp';
import img3 from '@assets/3.webp';
import part3_1 from '@assets/3-part-1.webp';
import part3_2 from '@assets/3-part-2.webp';
import part3_3 from '@assets/3-part-3.webp';

// Desktop: 3 imagens inteiras
export const desktopHeroData = [
  { id: 1, image: img1 },
  { id: 2, image: img2 },
  { id: 3, image: img3 },
];

// Mobile: 9 recortes horizontais
export const mobileHeroData = [
  { id: 1, image: part1_1 },
  { id: 2, image: part1_2 },
  { id: 3, image: part1_3 },
  { id: 4, image: part2_1 },
  { id: 5, image: part2_2 },
  { id: 6, image: part2_3 },
  { id: 7, image: part3_1 },
  { id: 8, image: part3_2 },
  { id: 9, image: part3_3 },
];

// Default: desktop (mudará no hook se mobile)
export const mockHeroData = desktopHeroData;
